import React from 'react';
import Navbar, { shouldExcludeNavbar } from './Navbar.tsx';
import { useLocation } from 'react-router-dom';

interface PageContentProps {
  children: React.ReactNode;
}

const PageContent = ({ children }: PageContentProps) => {
  const { pathname } = useLocation();

  // Use the centralized function from navbar to determine if navbar should be shown
  const showNavbar = !shouldExcludeNavbar(pathname);

  return (
    <div className="h-full min-h-screen w-full bg-gray-50/30">
      {/* Fixed navbar */}
      {showNavbar && <Navbar />}

      {/* Main Content Area - Add top padding when navbar is shown */}
      <div className={showNavbar ? 'pt-4' : ''}>
        <main className="h-full min-h-screen w-full">{children}</main>
      </div>
    </div>
  );
};

export default PageContent;
